import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {NgForm} from '@angular/forms';
import {UserStatusService} from '../user-status/user-status.service';
import {permissions} from '../../../permissions';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss'],
    providers: [
        UserStatusService
    ]
})
export class UserEditComponent implements OnInit {

    public model: any = {};
    public errors: any = {};

    private permissions = permissions;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private title: Title
    ) {
        this.title.setTitle('User Profile');
    }

    ngOnInit() {
        this.userService.getById(this.route.snapshot.params.id).subscribe(userData => {
            this.model = {
                id: userData.id,
                name: userData.name,
                username: userData.username,
                email: userData.email,
                status: userData.status
            };
        });
    }

    onChangeUserStatus(value: number) {
        this.model.status = value;
    }

    saveUser(form: NgForm) {

        const v = Object.assign({}, this.model, form.value);
        this.userService.save(v, false)
            .subscribe(
                result => {
                    if (result.errors) {
                        this.errors = result.errors;
                    } else {
                        this.onCancel();
                    }
                }
            );
    }

    onCancel() {
        this.router.navigate(['user/profile/' + this.route.snapshot.params.id]);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/user/user-edit/user-edit.component.ts